import { render, staticRenderFns } from "./PhysicianMap.vue?vue&type=template&id=3d210b92"
import script from "./PhysicianMap.vue?vue&type=script&lang=js"
export * from "./PhysicianMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports